module.exports = __webpack_public_path__ + "img/pro_two_1.ab0d0e1d.jpg";